export const exportHeaders = [
    {
        label: "Loyalty ID",
        key: "loyalty_id"
    },
    {
        label: "Billto",
        key: "customer_billto_account_number",
    },
    {
        label: "Shipto",
        key: "customer_account_number",
    },
    {
        label: "Old Rule ID",
        key: "old_rule_id",
    },
    {
        label: "Old Rule Description",
        key: "old_rule_description",
    },
    {
        label: "New Rule ID",
        key: "new_rule_id",
    },
    {
        label: "New Rule Description",
        key: "new_rule_description",
    },
    {
        label: "New Multiplier",
        key: "new_multiplier",
    },
    {
        label: "Sales Amount",
        key: "extended_sales_amount",
    },
    {
        label: "Old Points",
        key: "points",
    },
    {
        label: "New Points",
        key: "New_points"
    },
    {
        label: "Difference Points",
        key: "difference"
    },
    {
        label: "Order Id",
        key: "order_id"
    },
    {
        label: "Order Number",
        key: "order_number"
    },
    {
        label: "Order Line Number",
        key: "order_line_number"
    },
    {
        label: "Updated On",
        key: "updated_on"
    },
    {
        label: "Reason",
        key: "reason_code"
    },
    
]
